import React from 'react';
import "./Gallery.css"

const Gallery = () => {
 // const [gallery, setGallery] = useState([]);

    // useEffect(() => {
    //     fetch('gallery.json')
    //         .then(res => res.json())
    //         .then(data => setGallery(data))
    // }, [])
  return (
    <div>
      {/* <h4 className='mt-4'>Gallery</h4>
      <div  className='containerrr ps-5 pe-5'>
      {
                gallery.map(gallery => <Gallerys
                    gallery={gallery}
                   ></Gallerys>)
            }
      </div> */}
     
      
    </div>
  );
};

export default Gallery;
